import React from "react";
import { Table, ColumnDefinition, Typography } from "@bracket/ui";
import { Choice } from "@bracket/in-or-out-server";
import { timeAgo } from "./timeAgo";
import { StyledChip } from "./StyledChip";
import styled from "styled-components";
import { useRandomRecentWins, RecentWinRecord } from "./useRandomRecentWins";
import { useInOrOutStore } from "../../store/InOrOutStore";

const formatAddress = (address: string) => {
  if (!address) return "";
  return `${address.substring(0, 6)}....${address.substring(
    address.length - 3
  )}`;
};

const NoDataWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100px;
`;

export const TableRecentWins: React.FC = () => {
  const { tableRecentBars } = useInOrOutStore();
  useRandomRecentWins();

  const columns: ColumnDefinition<RecentWinRecord>[] = [
    {
      header: "Player ID",
      accessor: "id",
      render: (value) => (
        <Typography variant="p" color="var(--text-paragraph)">
          {formatAddress(value)}
        </Typography>
      ),
    },
    {
      header: "Choice",
      accessor: "choice",
      render: (value: Choice) => (
        <StyledChip $color={value === "IN" ? "green" : "gray"}>
          {value ?? "No choice"}
        </StyledChip>
      ),
    },
    {
      header: "Time",
      accessor: "time",
      render: (value) => (
        <Typography variant="p" color="var(--text-paragraph)">
          {timeAgo(value)}
        </Typography>
      ),
    },
    {
      header: "Total Bars Won",
      accessor: "total_bars",
    },
  ];

  if (!tableRecentBars || tableRecentBars.length === 0) {
    return (
      <NoDataWrapper>
        <p>No data available</p>
      </NoDataWrapper>
    );
  }

  return <Table data={tableRecentBars} columns={columns} highlightOnUpdate />;
};
